module.exports = __webpack_public_path__ + "static/media/Nan Ya-ROHS Test Report.af24545a.zip";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/Nan Ya-ROHS Test Report.zip
// module id = 1294
// module chunks = 0